import { render } from "./MainDashboard.vue?vue&type=template&id=2f1598b2"
import script from "./MainDashboard.vue?vue&type=script&lang=js"
export * from "./MainDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__